<template>
  <div class="container-fluid">
    <div id="sign-dialog" class="small-dialog zoom-anim-dialog mfp-hide">
      <h1>End game</h1>
      <div class="container">
        <div class="row">
          <div class="col-5 well text-center">{{ game.teams[0].name }}</div>
          <div class="col-1 well text-center">
            {{ game.teams[0].relation.goal_text }}
          </div>
          <div class="col-1 well text-center">
            {{ game.teams[1].relation.goal_text }}
          </div>
          <div class="col-5 well text-center">{{ game.teams[1].name }}</div>
          <div class="col-12 p-0">
            <h5>{{ game.teams[0].name }}</h5>
            <div class="well">
              <vue-signature-pad height="200px" ref="signaturePadFirstTeam" />
            </div>
          </div>
          <div class="col-12 p-0">
            <h5>{{ game.teams[1].name }}</h5>
            <div class="well">
              <vue-signature-pad height="200px" ref="signaturePadSecondTeam" />
            </div>
          </div>
          <div class="col-12 p-0">
            <h5>Judge</h5>
            <div class="well">
              <vue-signature-pad height="200px" ref="signaturePadJudge" />
            </div>
          </div>
          <div class="col-12 p-0">
            <button
              class="btn btn-lg btn-success w-100 mB-20"
              id="end__button"
              @click="endGame"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div class="col-4 info">{{ game.competition.name }}</div>
      <div class="col-4 info">
        Round: {{ game.round ? game.round.name : "Empty" }}
      </div>
      <div class="col-4 info">{{ game.field.name }}</div>
    </div>
    <div class="row">
      <div class="col-4 p-0" id="teamA">
        <team
          :team="game.teams[0]"
          :game="game"
          :robotsNumber="0"
          ref="team1"
          @goal="goal(0, $event)"
        ></team>
      </div>
      <div class="col-4 p-0">
        <div class="row m-0">
          <div class="col-3 well text-center team-goal" id="teamAGoal">
            {{ game.teams[0].relation.goal_text }}
          </div>
          <div class="col-6 well text-center time">{{ timerText }}</div>
          <div class="col-3 well text-center team-goal" id="teamBGoal">
            {{ game.teams[1].relation.goal_text }}
          </div>
        </div>
        <div class="well text-center game-control">
          <button
            class="btn btn-lg w-100 mB-20 control-button"
            v-bind:class="[game.isActive ? 'btn-warning' : 'btn-success']"
            @click="startButton"
          >
            {{ game.isActive ? "Pause" : "Start" }}
          </button>
          <button
            class="btn btn-lg btn-primary w-100 mB-20 control-button"
            @click="reset"
          >
            Reset time
          </button>
          <button
            class="btn btn-lg btn-primary w-100 mB-20 control-button"
            @click="swap"
          >
            Switch
          </button>
          <button
            class="btn btn-lg btn-primary w-100 mB-20 control-button"
            @click="kickoff"
          >
            KickOff
          </button>
          <button
            class="btn btn-lg btn-danger w-100 mB-20 not-confirm control-button sign-dialog"
            href="#sign-dialog"
          >
            End Game
          </button>
          <label class="badge badge-success" id="server_status">Server</label>
        </div>
      </div>
      <div class="col-4 p-0" id="teamB">
        <team
          :team="game.teams[1]"
          :game="game"
          :robotsNumber="2"
          ref="team2"
          @goal="goal(1, $event)"
        ></team>
      </div>
    </div>
  </div>
</template>

<script>
import Team from "./Team";
import VueSignaturePad from "vue-signature-pad";
export default {
  components: {
    Team,
    VueSignaturePad,
  },
  data() {
    return {
      game: null,
      update: null,
    };
  },
  beforeMount() {
    if (!window.gameraw.time_of_period)
      window.gameraw.time_of_period =
        window.gameraw.round && window.gameraw.round.time_of_half != null
          ? window.gameraw.round.time_of_half
          : window.gameraw.competition.time_of_half;

    if (!window.gameraw.time_of_damage)
      window.gameraw.time_of_damage =
        window.gameraw.round && window.gameraw.round.time_of_damage != null
          ? window.gameraw.round.time_of_damage
          : window.gameraw.competition.time_of_damage;

    window.gameraw.isActive = false;

    if (!window.gameraw.timer)
      window.gameraw.timer = {
        seconds: 0,
        interval: null,
      };
    window.gameraw.teams[0].relation.goal_text =
      window.gameraw.teams[0].relation.goal;
    window.gameraw.teams[1].relation.goal_text =
      window.gameraw.teams[1].relation.goal;
    if (!window.gameraw.swap) window.gameraw.swap = false;

    this.game = window.gameraw;
  },
  mounted() {
    if (this.game.swap) {
      $(() => {
        this.swap(false, 400, 400, 400);
      });
    }
    $(() => {
      $(".sign-dialog").magnificPopup({
        type: "inline",
        fixedContentPos: false,
        fixedBgPos: true,
        overflowY: "hidden",
        closeBtnInside: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        mainClass: "my-mfp-slide-bottom",
      });
    });
    if (this.game.competition.server_connection) {
      this.update = setInterval(() => {
        this.saveResult();
      }, this.game.competition.server_connection_time * 1000);
    }
  },
  methods: {
    startButton() {
      if (!this.game.isActive) {
        this.game.isActive = true;
        this.game.timer.interval = setInterval(() => {
          this.game.timer.seconds++;
          if (this.game.timer.seconds == this.game.time_of_period - 5) {
            this.blink(
              document.getElementById("game_play"),
              "play_game_opacity",
              10000
            );
          }
        }, 1000);
      } else {
        this.game.isActive = false;
        clearInterval(this.game.timer.interval);
      }
    },
    goal(team_index, change) {
      if (change > 0 || this.game.teams[team_index].relation.goal) {
        this.game.teams[team_index].relation.goal_text =
          this.game.teams[team_index].relation.goal +
          (change > 0 ? "+1" : "-1");
        this.game.teams[team_index].relation.goal += change;
        setTimeout(() => {
          this.game.teams[team_index].relation.goal_text = this.game.teams[
            team_index
          ].relation.goal;
        }, 5000);
      }
    },
    pad2(number) {
      return (number < 10 ? "0" : "") + number;
    },
    blink(element, className = "btn-warning", time = 5000) {
      var blinkTimer = setInterval(() => {
        element.classList.toggle(className);
      }, 500);
      setTimeout(() => {
        clearInterval(blinkTimer);
        element.classList.remove(className);
      }, time);
    },
    kickoff() {
      this.$refs.team1.kickoff();
      this.$refs.team2.kickoff();
    },
    swap(flag = true, first_time = 600, second_time = 1000, third_time = 1000) {
      if (flag) this.game.swap = !this.game.swap;
      $("#teamA").swap({
        target: "teamB",
        opacity: "0.5",
        speed: first_time,
        callback() {
          $("#teamAGoal").swap({
            target: "teamBGoal",
            opacity: "0.5",
            speed: third_time,
          });
        },
      });
    },
    reset() {
      this.kickoff();
      this.game.isActive = false;
      this.game.timer.seconds = 0;
      clearInterval(this.game.timer.interval);
    },
    saveResult(redirect = false) {
      this.game.teams[0].damages = this.$refs.team1.damages;
      this.game.teams[1].damages = this.$refs.team2.damages;
      this.axios
        .post(window.urls.save, this.game)
        .then((resp) => {
          if (redirect) window.location.href = "/myGames";
          document
            .getElementById("server_status")
            .classList.remove("badge-danger");
        })
        .catch((resp) => {
          $("#end__button").removeClass("disabled");
          $("#end__button").find("i").remove();
          $("#end__button").prepend('<i class="fa fa-close"></i> ');
          setTimeout(() => {
            $("#end__button").find("i.fa").remove();
            $("#end__button").find("i.ti-save-alt").css("display", "inherit");
          }, 1000);
          document
            .getElementById("server_status")
            .classList.add("badge-danger");
        });
    },
    endGame(event) {
      if (
        this.$refs.signaturePadFirstTeam.isEmpty() ||
        this.$refs.signaturePadSecondTeam.isEmpty() ||
        this.$refs.signaturePadJudge.isEmpty()
      ) {
        alert("Not all signature! Try again");
        return true;
      }
      clearInterval(this.update);
      $("#end__button").addClass("disabled");
      $("#end__button").prepend(
        '<i class="fa fa-circle-o-notch fa-spin fa-fw"></i> '
      );
      this.game.teams[0].relation.signature = this.$refs.signaturePadFirstTeam.saveSignature();
      this.game.teams[1].relation.signature = this.$refs.signaturePadSecondTeam.saveSignature();
      this.game.signature = this.$refs.signaturePadJudge.saveSignature();
      this.game.isFinished = true;
      this.saveResult(true);
    },
  },
  computed: {
    timerText() {
      return (
        this.pad2(Math.floor(this.game.timer.seconds / 60)) +
        ":" +
        this.pad2(Math.floor(this.game.timer.seconds % 60))
      );
    },
  },
};
</script>